import { GetterTree } from 'vuex';
import {RootState, Lookup, LookupIcon, LookupDistance} from '../types';
import {Purchase, UserState} from '@/store/User/types';
import * as _ from 'lodash';


export const getters: GetterTree<UserState, RootState> = {
    getPurchase(state): (what: any) => (Purchase | undefined ) {
        return (what: any) => {
            return _.find(state.purchases, {what});
        };
    },
    getDiagnosis(state): string[] | number[] | LookupIcon[] | LookupDistance [] |  undefined {
        return state.diagnosis ? state.diagnosis.values : undefined ;
    },
    getUserType(state): string[] | number[] | LookupIcon[] | LookupDistance [] | undefined {
        return state.userType ? state.userType.value : undefined ;
    },
    getFunStuff(state): string[] | number[] | LookupIcon[] | undefined {
        return state.funStuff ? state.funStuff.values : [] ;
    },
    getGroupFunStuff(state): string[] | number[] | LookupIcon[] | undefined {
        return state.groupFunStuff ? state.groupFunStuff.values : [] ;
    },
    getFirstHalfFun(state): string[] | number[] | LookupIcon[] | undefined {
        return (state.funStuff && state.funStuff.values) ?
            state.funStuff.values.slice(0, Math.ceil(state.funStuff.values.length / 2)) : undefined ;
    },
    getSecondHalfFun(state): string[] | number[] | LookupIcon[] | undefined {
        return (state.funStuff && state.funStuff.values) ?
            state.funStuff.values.slice(Math.ceil(state.funStuff.values.length / 2)) : undefined ;
    },
    getDistances(state): string[] | number[] | LookupIcon[] | LookupDistance [] | undefined {
        return state.distance ? state.distance.value : undefined ;
    },

};
